module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-10-a66619d10c84cc31fcc2045fe2621cdc.png";